"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTNER_INQUIRY_INVITE_PRODUCTS = exports.PARTNER_INQUIRY_CREATION_PRODUCTS = exports.PARTNER_INQUIRY_PRODUCT_TO_AVEN_PRODUCT_TYPE = exports.PartnerInquiryProduct = void 0;
const avenProductType_1 = require("./avenProductType");
/**
 * Partner-facing inquiry identity; not every product supports an MLO invite link.
 * @TranslateToPython
 */
var PartnerInquiryProduct;
(function (PartnerInquiryProduct) {
    PartnerInquiryProduct["AVEN_CASH"] = "AVEN_CASH";
    PartnerInquiryProduct["AVEN_HOME_PURCHASE"] = "AVEN_HOME_PURCHASE";
    PartnerInquiryProduct["AVEN_UCC"] = "AVEN_UCC";
    PartnerInquiryProduct["AVEN_DEPOSIT"] = "AVEN_DEPOSIT";
})(PartnerInquiryProduct || (exports.PartnerInquiryProduct = PartnerInquiryProduct = {}));
/** Canonical Aven product for each saved inquiry category. */
exports.PARTNER_INQUIRY_PRODUCT_TO_AVEN_PRODUCT_TYPE = {
    [PartnerInquiryProduct.AVEN_CASH]: avenProductType_1.AvenProductType.HOME_EQUITY_CASH,
    [PartnerInquiryProduct.AVEN_HOME_PURCHASE]: avenProductType_1.AvenProductType.HOME_PURCHASE_HELOC,
    [PartnerInquiryProduct.AVEN_UCC]: avenProductType_1.AvenProductType.REWARDS_CARD,
    [PartnerInquiryProduct.AVEN_DEPOSIT]: avenProductType_1.AvenProductType.DEPOSIT,
};
/** Products supported by dashboard inquiry creation, independently of invite-link support. */
exports.PARTNER_INQUIRY_CREATION_PRODUCTS = [PartnerInquiryProduct.AVEN_CASH, PartnerInquiryProduct.AVEN_HOME_PURCHASE];
/** Products currently supported by the MLO invite creation flow. */
exports.PARTNER_INQUIRY_INVITE_PRODUCTS = [PartnerInquiryProduct.AVEN_CASH, PartnerInquiryProduct.AVEN_HOME_PURCHASE];
